<template>
    <div class="live-comment-container">
        <!-- Scrollable area -->
        <div style="display: flex; align-items: center; justify-content: space-between; padding: 15px; font-weight: bold;">
            <div>Live Chat</div>
            <div style="display: flex; align-items: center; color:gray; font-size: 0.9em;">
                <ion-icon style="font-size:1.1em; margin-right: 5px;" :icon="eyeOutline"></ion-icon>
                <span>{{ viewers }}</span>
            </div>
        </div>
        <div class="scrollable-container" ref="chatList">
            <ion-list lines="none">
                <div v-if="loadingComments">
                    <ion-item v-for="n in 3" :key="n" class="ion-no-padding">
                        <ion-skeleton-text
                            style="margin: 5px 0 0 12px; width: 24px; height: 24px; margin-right:10px; border-radius: 12px;"
                            :animated="true"></ion-skeleton-text>
                        <ion-skeleton-text style="width: 100%; height: 24px; margin: 5px 0 0 0px;"
                            :animated="true"></ion-skeleton-text>
                    </ion-item>
                </div>
                <div v-if="!loadingComments && liveComments.length==0 && isLive"
                    style="padding: 10px; text-align: center;">
                    <ion-icon :icon="chatbubble" style="font-size: 44px; color: var(--ion-color-primary);"></ion-icon>
                    <p style="font-size: 20px; font-weight: bold;">No messages yet</p>
                    <p style="font-size: 16px;">Be the first to chat</p>
                </div>
                <ion-item detail="false" v-for="(comment, commentIndex) in liveComments" :key="commentIndex">
                    <div class="chat-row" style="display:flex;">
                        <div style="margin: 0 10px 0 0; cursor: pointer;">
                            <img @click="goToProfile(comment.user_id)" class="post-profile-pic-xs"
                                v-if="comment.profile_pic != '' && comment.profile_pic != undefined"
                                :src="profilepath + comment.profile_pic" />
                            <img @click="goToProfile(comment.user_id)" class="post-profile-pic-xs"
                                src="/assets/spyguy.png"
                                v-if="comment.profile_pic == '' || comment.profile_pic == undefined" />
                        </div>
                        <div>
                            <div v-if="comment.comment_text != '[GIF]'" class="chat-bubble">
                                <p style="padding:0px; margin: 0px 0 0 0px;">
                                    <strong>{{ comment.user_name }}</strong> <span v-html="comment.comment_text"></span>
                                </p>
                            </div>
                            <div v-if="comment.comment_text == '[GIF]'" class="chat-bubble">
                                <div style="display: flex; align-items: center; margin: 10px 0px 10px 0px;">
                                    <span style="padding: 0px; margin: 0px 10px 0px 0px;">
                                        <strong>{{ comment.user_name }}</strong>
                                    </span>
                                    <img
                                        style="border-radius: 8px; width: auto; height: 80px;"
                                        :src="comment.gif_url"
                                    />
                                </div>
                            </div>
                            <div v-show="comment.link_url != '' && comment.link_url != null" style="margin-top: 10px;"
                                @click="openLink(comment.link_url)">
                                <ion-grid class="ion-padding url-block">
                                    <ion-row class="ion-align-items-center">
                                        <ion-col class="ion-no-padding" size="small"
                                            v-show="comment.link_image != '' && comment.link_image != null">
                                            <img class="link_image cover" :src="comment.link_image">
                                        </ion-col>
                                        <ion-col>
                                            <div class="link">{{ getHostName(comment.link_url) }}</div>
                                            <div class="link_text"
                                                v-show="comment.link_text != '' || comment.link_text != undefined">{{
                                                comment.link_text }}</div>
                                        </ion-col>
                                    </ion-row>
                                </ion-grid>
                            </div>
                            <div style="display:none;" class="chat-options">
                                <p><span style="cursor: pointer; padding-right:5px;">{{ getUploadDate(comment.date_time,
                                        this.$root.$i18n.locale) }}&nbsp;</span>
                                    <span v-if="comment.liked_it == ''" style="cursor: pointer; padding-right:5px;"
                                        @click="commentLike(comment)">{{ $t('buttons.like') }}&nbsp;</span>
                                    <span v-if="comment.liked_it == 'yes'" style="cursor: pointer; padding-right:5px;"
                                        @click="commentLike(comment)"><strong>{{ $t('buttons.liked')
                                            }}</strong>&nbsp;</span>
                                    <span v-if="comment.parent_id == ''" style="cursor: pointer; padding-right:5px;"
                                        @click="commentReply(comment)">{{ $t('buttons.reply') }}&nbsp;</span>
                                    <span v-if="comment.likes > 0">&nbsp;{{ comment.likes }} {{ $t('buttons.likes')
                                        }}&nbsp;</span>
                                    <ion-icon @click="openPopover($event, comment)" :icon="ellipsisHorizontal"
                                        style="cursor: pointer; padding: 0px; margin-left: 15px; font-size:0.793rem;"></ion-icon>
                                </p>
                            </div>
                        </div>
                    </div>
                </ion-item>
            </ion-list>
        </div>
    </div>
    <div class="floating-heart" ref="floatingHeart">
        <ion-icon :icon="heartOutline"></ion-icon>
    </div>
    <ion-footer v-if="isLive" class="ion-no-border">
        <div v-if="loadingLink && linkPreviews == undefined" class="url-block" style="margin-top: 2%; cursor:auto;">
            <div style="margin:5px; display:block; width:100%; height: 30px; text-align:center;">
                <ion-spinner></ion-spinner>
            </div>
            <div style="margin-bottom:10px; text-align:center;">{{ $t('loadmessage.links') }}</div>
        </div>
        <div v-if="linkPreviews != undefined">
            <ion-grid class="ion-no-padding url-block">
                <ion-row class="ion-align-items-center">
                    <ion-col class="ion-no-padding" size="small"
                        v-if="linkPreviews.link_image != '' && linkPreviews.link_image != null">
                        <img class="link_image cover" :src="linkPreviews.link_image">
                    </ion-col>
                    <ion-col>
                        <div class="link">{{ getHostName(linkPreviews.link_url) }}</div>
                        <div class="link_text"
                            v-show="linkPreviews.link_text != '' || linkPreviews.link_text != undefined">
                            {{
                            linkPreviews.link_text }}</div>
                    </ion-col>
                    <ion-col size="small">
                        <div @click="removeLink" class="remove-link"><ion-icon :icon="close"></ion-icon></div>
                        <div @click="retryLink" class="remove-link"><ion-icon :icon="refresh"></ion-icon></div>
                    </ion-col>
                </ion-row>
            </ion-grid>
        </div>
        <ion-list v-if="userSuggest" style="max-height: 110px; overflow: scroll;">
            <ion-item button v-for="(userdata, itemIndex) in usernames" :key="itemIndex"
                @click="updateUsername(userdata.username)">
                <img class="post-profile-pic" placeholder="/assets/SuperLikes/like_icon.png"
                    v-if="userdata.profile_pic != '' && userdata.profile_pic != undefined" @error="imgUrlAlt"
                    :src="profilepath + userdata.profile_pic">
                <img class="post-profile-pic" src="/assets/spyguy.png"
                    v-if="userdata.profile_pic == '' || userdata.profile_pic == undefined">
                <ion-label>{{ userdata.username }}
                    <p>{{ userdata.name }}</p>
                </ion-label>
            </ion-item>
        </ion-list>
        <ion-list v-if="hashtagSuggest" style="max-height: 110px; overflow: scroll;">
            <ion-item button v-for="(hashtag, itemIndex) in hashtags" :key="itemIndex" @click="updateHashtag(hashtag)">
                <ion-label><strong>{{ hashtag }}</strong></ion-label>
            </ion-item>
        </ion-list>
        <ion-toolbar style="--background: var(--ion-item-background, var(--ion-background-color, #fff));">
            <ion-item lines="none" v-if="this.parentId != ''"><ion-chip style="margin-top:5px;"><strong>{{
                        $t('buttons.reply')
                        }}:</strong></ion-chip>
            </ion-item>
            <ion-item lines="none" detail="false" style="padding:8px 0 8px 0;">
                <textarea shape="round" rows="1" ref="comment-box" class="comment-text-area" v-model="commentText"
                    @input="saveText" :required="true" :auto-grow="true" :autocapitalize="true"
                    :placeholder="'Send a message'" inputmode="text"></textarea>
                <ion-button ref="post-button" id="post-button" fill="clear" @click="postComment"><ion-icon
                        :icon="send"></ion-icon></ion-button>
            </ion-item>
            <ion-item>
                <ion-button fill="clear" color="none"
                    style="margin-left:5px; color:rgba(var(--dashboard-contrast-color-rgb), 1.0);" id="gif-button"
                    @click="showGifs()">{{
                    $t('buttons.gif') }}</ion-button>
                <ion-button style="margin-left:5px; color:rgba(var(--dashboard-contrast-color-rgb), 1.0);" fill="clear"
                    color="none" id="emoji-button" @click="openEmojiPopover">
                    <ion-icon :icon="happyOutline"></ion-icon>
                </ion-button>
                <ion-button style="margin-left:5px; color:rgba(var(--dashboard-contrast-color-rgb), 1.0);" fill="clear"
                    color="none" id="heart-button" @click="triggerHeartAnimation($event)">
                    <ion-icon :icon="heartOutline"></ion-icon>
                </ion-button>
            </ion-item>
        </ion-toolbar>
    </ion-footer>
    <ion-footer v-else>
        <ion-toolbar>
            <ion-title>Live Chat Has Ended</ion-title>
        </ion-toolbar>
    </ion-footer>
</template>
    
<script>
import { IonButton, modalController, IonList, IonItem, IonLabel, IonIcon, popoverController, alertController, IonSpinner, IonToolbar, IonGrid, IonCol, IonRow, IonFooter, IonChip, IonSkeletonText, IonTitle } from '@ionic/vue';
import { closeOutline, people, checkmark, closeCircle, heartOutline, camera, ellipsisHorizontal, chatbubble, send, image, cog, close, refresh, happyOutline, thumbsUpOutline, eyeOutline } from 'ionicons/icons';
import { defineComponent, defineAsyncComponent } from 'vue';
import { addLinksToText, checkForUsers, getHostName, checkForHashtags, checkForLinks } from '@/composables/text';
//import { PushNotifications } from '@capacitor/push-notifications';

import getEnv from '@/utils/env'
import Popover from '@/components/Popover.vue'

const ReportPostModal = defineAsyncComponent(() =>
    import('@/components/posts/ReportPost.vue'))

const GifModal = defineAsyncComponent(() =>
    import('@/components/GifModal.vue'))

import { getUploadDate } from '@/composables/date';
import { Browser } from '@capacitor/browser';
import EmojiPopover from "@/components/EmojiPopover.vue";

export default defineComponent({
    name: 'LiveCommentContainer',
    props: {
        videoId: { type: Number, default: null },
        isLive: { type: Boolean, default: false },
    },
    setup() {
        return {
            closeOutline,
            people,
            checkmark,
            closeCircle,
            heartOutline,
            camera,
            ellipsisHorizontal,
            chatbubble,
            send,
            image,
            cog,
            addLinksToText,
            getHostName,
            close, 
            refresh,
            getUploadDate,
            happyOutline,
            thumbsUpOutline,
            eyeOutline
        }
    },
    data() {
        return {
            path: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET'),
            profilepath: getEnv('AWS_URL') + getEnv('PHOTO_BUCKET') + '/profile/',
            commentText: '',
            parentId: 0,
            editmessageId: 0,
            userSuggest: false,
            hashtagSuggest: false,
            currentPage: 0,
            pageSize: 10,
            pagingDateTime: null,
            loadingLink: false,
            pollData: null,
            hovered: [],
            showLoadMore: true,
            showLoading: false,
            loadingComments: true,
            editCommentId: 0,
            showing: false
        }
    },
    components: { IonButton, IonList, IonItem, IonLabel, IonIcon, IonSpinner, IonFooter,  IonGrid, IonCol, IonRow, IonToolbar, IonChip, IonSkeletonText, IonTitle },
    async mounted() {
        try {
            let action = 'view';
            if(this.isLive){
                action = 'join';
            }
            await this.$store.dispatch('livecomment/updateLiveViewers', {
                video_id: this.videoId,
                action: action,
            });

            // Initialize WebSocket
            await this.$store.dispatch("livecomment/initializeWebSocket", {
                video_id: this.videoId,
            });

            // Fetch initial comments
            await this.fetchComments();

            if (!this.webSocketConnected) {
                this.pollData = setInterval(() => {
                    console.log('Manually polling, no WebSocket connection');
                    this.pollThread();
                }, 15000); // Poll every 15 seconds
            }
            
            // Scroll to the bottom after loading comments
            this.$nextTick(() => {
                this.scrollToBottom();
            });
        } catch (error) {
            console.error("Failed to initialize live comments:", error);
        }
    },
    unmounted() {
        if (this.pollData) {
            clearInterval(this.pollData);
            this.pollData = null;
        }

        // Close WebSocket connection when the component is destroyed
        this.$store.dispatch("livecomment/closeWebSocket");
    },
    beforeUnmount() {
        if(this.isLive){
            try {
                this.$store.dispatch('livecomment/updateLiveViewers', {
                    video_id: this.videoId,
                    action: 'leave',
                });
            } catch (error) {
                console.error('Failed to leave live viewers:', error);
            }
        }
    },
    methods: {
        scrollToBottom() {
            const container = this.$refs.chatList; // Reference to the scrollable container
            if (container) {
                container.scrollTop = container.scrollHeight; // Scroll to the bottom
            }
        },
        async showComments(loader) {
            this.showing = loader;
            let response = await this.$store.dispatch("comments/show", {
                imageid: this.image.id,
                currentPage: this.currentPage
            });
            if(response){
                this.showing = false;
                if (response['error'] != undefined) {
                    console.log('Error: ' + response['error']);
                }
            }
        },
        async loadMoreComments() {
            this.currentPage = this.currentPage + 10;
            this.showComments(true);
        },
        goToProfile(id) {
            //console.log('go to profile:' + id);
            this.closeModal();
            this.$router.push({ name: 'profile', params: { id: id } });
        },
        async saveText() {
            let textInfo = this.commentText;
            //console.log('checking text ' + this.commentText);
            var postButton = this.$refs['post-button'].$el;
            this.resize();

            if (textInfo.length > 0) {
                postButton.disabled = false;
            } else {
                postButton.disabled = true;
            }

            this.hashtagSuggest = checkForHashtags(textInfo);
            this.userSuggest = checkForUsers(textInfo);
            this.loadingLink = checkForLinks(textInfo, this.linkPreviews);
            //this.checkForHashtags(textInfo);
            //this.checkForUsers(textInfo);
            //this.checkForLinks(textInfo);
        },
        async openEmojiPopover(event) {
            const popover = await popoverController.create({
                component: EmojiPopover,
                event: event, // Anchor the popover to the button click event
                translucent: true,
                cssClass: "emoji-popover-class",
            });

            popover.onDidDismiss().then((data) => {
                console.log(data, 'emoji data');
                if (data.data) {
                    this.commentText += data.data; // Append the selected emoji to the comment text
                    this.postComment();
                }
            });

            return await popover.present();
        },
        resize() {
            const textarea = this.$refs['comment-box'];
            let newHeight = textarea.scrollHeight;
            if (this.commentText.length == 0) {
                textarea.style.height = '44px';
            } else if (newHeight > 44) {
                textarea.style.height = newHeight + 'px';
            }
        },
        updateUsername(usernameString) {
            var splitString = this.commentText.split(' ');
            let lastWord = splitString[splitString.length - 1];
            this.commentText = this.commentText.replace(lastWord, '@' + usernameString + ' ');
            this.userSuggest = false;
        },
        updateHashtag(hashtagString) {
            //console.log('selected: ' + hashtagString);
            var splitString = this.commentText.split(' ');
            let lastWord = splitString[splitString.length - 1];
            this.commentText = this.commentText.replace(lastWord, hashtagString + ' ');
            this.hashtagSuggest = false;
        },

        async openPopover(ev, comment) {
            //console.log(story);
            var type = 'comment';
            var myProfileId = this.$store.state.profile.id;
            //console.log(this.$store.state.profile.profileData);
            if (comment.user_id == myProfileId) {
                type = 'my-comment';
            } else if (comment.owner_id == myProfileId) {
                type = 'my-comment-post';
            }

            //console.log(type);
            const popover = await popoverController
                .create({
                    component: Popover,
                    cssClass: 'my-custom-class',
                    event: ev,
                    translucent: true,
                    componentProps: {
                        name: this.$t('modalhead.options'),
                        type: type,
                        data: comment
                    }
                })
            await popover.present();

            const { role } = await popover.onDidDismiss();
            if (role == "edit-comment") {
                this.editComment(comment);
            } else if (role == "delete-comment") {
                // alert prompt
                this.presentAlert(comment);
            } else if (role == "report-comment") {
                this.openReportCommentModal(comment);
            }
            //console.log('onDidDismiss resolved with role', role);
        },
        commentReply(comment) {
            this.parentId = comment.id;
            //console.log(comment);
        },
        likeStyle(comment) {
            var rowClass = '';
            if (comment.liked_it == 'yes') {
                rowClass = 'comment-like-active md hydrated';
            } else {
                rowClass = 'comment-like md hydrated';
            }
            //console.log(comment);
            //console.log('change style to: ' + rowClass);
            return rowClass;
        },
        async commentLike(comment) {
            //console.log(comment);
            let response = await this.$store.dispatch("comments/like", {
                id: comment.id,
            });
            if (response['error'] != undefined) {
                // this.loadingIndicator.dismiss();
                console.log('Error: ' + response['error']);
            } else {
                this.parentId = '';
                this.commentText = '';
                this.editCommentId = 0;
                this.showComments(false);
            }

        },
        async likeItem() {
            //console.log("liked item");
            if (this.$store.state.auth.token != "") {
                //console.log(this.pik_id);
                const role = "Love It";
                let response = await this.$store.dispatch("likes/likeit", {
                    type: role,
                    imageid: this.videoId,
                });
                if (response) {
                    if (response["error"] != null) {
                        console.log(response["error"], "error liking");
                    } else {
                        this.$emit('update:likes', this.likes + 1);
                        this.$emit('update:likeittype', role);
                        this.$emit('update:likeit', 1);
                    }
                } else {
                    console.log("unknown error");
                }
            }
        },
        async openLink(link_url) {
            await Browser.open({ url: link_url });
            //window.open(link_url, '_blank');
        },
        async editComment(comment) {
            this.editCommentId = comment.id;
            this.commentText = comment.comment_text;
            this.$nextTick(async function () {
                this.$refs['comment-box'].focus();
                if(this.commentText.length>75) {
                    this.$refs['comment-box'].setAttribute("style","height:88px");
                }else{
                    this.$refs['comment-box'].setAttribute("style","height:44px");
                }
            });
            //this.$refs['comment-box'].autoGrow = true;    
        },
        async openReportCommentModal(comment) {
            const modal = await modalController
                .create({
                    component: ReportPostModal,
                    cssClass: 'modal-custom-class',
                    componentProps: {
                        title: this.$t('modalhead.reportComment'),
                        image: comment,
                        type: 3,
                    }
                })
            return await modal.present();
        },
        async showGifs() {
            const modal = await modalController
                .create({
                    component: GifModal,
                    cssClass: 'modal-custom-class',
                    componentProps: {
                        title: 'Tenor Gifs',
                        item: null,
                        liveVideoId: this.videoId
                    }
                })
            modal.onDidDismiss().then((data) => {
                if (data != null) {
                    this.showComments(true);
                }
            });
            return await modal.present();

        },
        
        async presentAlert(comment) {
            // calculate post id here
            var message = this.$t('alertmessage.deleteComment');
            var header = this.$t('alerthead.deleteComment');
            var buttonName = this.$t('buttons.delete');

            const alert = await alertController
                .create({
                    cssClass: 'my-custom-class',
                    header: header,
                    message: message,
                    buttons: [
                        {
                            text: this.$t('buttons.cancel'),
                            role: 'cancel',
                            cssClass: 'secondary'
                        },
                        {
                            text: buttonName,
                            handler: async () => {
                                let response = await this.$store.dispatch("comments/delete", {
                                    id: comment.id
                                });
                                if (response) {
                                    if (response['error'] != null) {
                                        this.error = response['error'];
                                    }
                                    this.$store.commit('comments/setAddComment', this.$store.state.comments.addComment - 1);
                                }
                                this.showComments(true);
                            },
                        },
                    ],
                });
            await alert.present();
        },
        /* async postComment() {
            if (this.commentText.trim() != '') {
                var postButton = this.$refs['post-button'].$el;
                postButton.disabled = true;

                let link_url = '';
                let link_text = '';
                let link_image = '';
                if (this.linkPreviews != undefined) {
                    link_url = this.linkPreviews.link_url;
                    link_text = this.linkPreviews.link_text;
                    link_image = this.linkPreviews.link_image;
                }
                let response = await this.$store.dispatch("comments/post", {
                    imageid: this.image.id,
                    parent_id: this.parentId,
                    comment: this.commentText,
                    comment_id: this.editCommentId,
                    link_url: link_url,
                    link_text: link_text,
                    link_image: link_image
                });
                if (response['error'] != undefined) {
                    // this.loadingIndicator.dismiss();
                    postButton.disabled = false;
                    console.log('Error: ' + response['error']);
                } else {
                    //console.log('adding comment');
                    this.$store.commit('helpers/setLinkUrl', undefined);
                    this.loadingLink = false;
                    this.$store.commit('comments/setAddComment', this.$store.state.comments.addComment + 1);
                    this.currentPage = 0;
                    this.parentId = '';
                    this.commentText = '';
                    this.editCommentId = 0;
                    this.showComments(true);
                    postButton.disabled = false;
                    this.resize();
                }
            }
        },*/
        removeLink() {
            this.loadingLink = false;
            this.$store.commit('helpers/setLinkUrl', undefined);
        },
        retryLink() {
            this.removeLink();
            this.$store.commit('helpers/setLinkUrl', { retryLink: true });
            this.saveText();
        },
        imgUrlAlt(event) {
            event.target.src = "/assets/spyguy.png";
        },
        async postComment() {
            if (this.commentText.trim() != '') {
                var postButton = this.$refs['post-button'].$el;
                postButton.disabled = true;

                //const videoId = this.$route.params.video_id; // Assuming video_id is passed in the route

                // Prepare the payload for the createLiveComment action
                const payload = {
                    video_id: this.videoId,
                    parent_id: null, // Assuming no parent for now
                    comment_text: this.commentText.trim(),
                    gif_url: this.linkPreviews?.link_url || null, // Assuming GIF URL is part of link previews
                    gif_width: 0, // Add logic to set GIF width if applicable
                    gif_height: 0, // Add logic to set GIF height if applicable
                    link_url: this.linkPreviews?.link_url || null,
                    link_image: this.linkPreviews?.link_image || null,
                    link_text: this.linkPreviews?.link_text || null,
                };

                // Clear the comment text and scroll to the bottom
                this.loadingLink = false;
                this.commentText = '';
                this.$store.commit('helpers/setLinkUrl', undefined);

                // Dispatch the action to create a live comment
                let response = await this.$store.dispatch("livecomment/createLiveComment", payload);

                if (response['error'] != undefined) {
                    console.log('Error: ' + response['error']);
                } else {
                    postButton.disabled = false;
                    this.resize();
                    this.scrollToBottom(); // Scroll to the bottom after sending a message
                }

                /* let messageUpdate = {
                    thread_id: this.messageThread,
                    user_id: this.$store.state.profile.id,
                    from_display_name: this.$store.state.profile.fullname,
                    profile_pic: this.$store.state.profile.pic,
                    plaintext_message: this.messageTextBox,
                    piklist_id: "",
                    link_url: link_url,
                    link_image: link_image,
                    link_text: link_text,
                    date_time: new Date()
                } */
                
               /* let response = await this.$store.dispatch("messages/send", {
                    thread_id: this.messageThread,
                    message: messageUpdate.plaintext_message,
                    piklist_id: '',
                    link_url: link_url,
                    link_text: link_text,
                    link_image: link_image
                });

                */
            }
        },
        async fetchComments() {
            try {
                await this.$store.dispatch("livecomment/fetchLiveComments", {
                    video_id: this.videoId,
                    currentPage: 0,
                    totalList: 20,
                });
                this.loadingComments = false;
            } catch (error) {
                console.error("Failed to fetch live comments:", error);
                this.loadingComments = false;
            }
        },
        async toggleLike(comment) {
            try {
                const increment = comment.liked_it !== "yes";
                await this.$store.dispatch("livecomment/toggleLikeComment", {
                    live_comment_id: comment._id,
                    increment,
                });
            } catch (error) {
                console.error("Failed to toggle like:", error);
            }
        },
        async deleteComment(comment) {
            try {
                await this.$store.dispatch("livecomment/deleteLiveComment", {
                    id: comment._id,
                });
            } catch (error) {
                console.error("Failed to delete comment:", error);
            }
        },
        isCommentOwner(comment) {
            return comment.user_id === this.$store.state.profile.id;
        },
        resizeTextarea() {
            const textarea = this.$refs.commentTextarea;
            textarea.style.height = "auto";
            textarea.style.height = `${textarea.scrollHeight}px`;
        },
        triggerHeartAnimation(event) {
            const thumbsUpElement = this.$refs.floatingHeart;
            const button = event.target.getBoundingClientRect(); // Get the button's position
            console.log(button);
            console.log(window.innerWidth);
            let xFactor = button.x;
            if(window.innerWidth > 960) {
                xFactor = button.x - 270; // Adjust for larger screens
            }
            if (thumbsUpElement) {
                // Set the starting position of the thumbs-up element
                thumbsUpElement.style.left = `${xFactor + button.width / 2}px`; // Center horizontally
                thumbsUpElement.style.bottom = `${window.innerHeight - button.bottom}px`; // Calculate bottom position
                thumbsUpElement.style.opacity = "1"; // Ensure it's visible

                // Add the animation class
                thumbsUpElement.classList.add("animate-thumbs-up");

                // Remove the animation class after the animation ends
                setTimeout(() => {
                    thumbsUpElement.classList.remove("animate-thumbs-up");
                    thumbsUpElement.style.opacity = "0"; // Hide after animation
                }, 1000); // Match the duration of the animation
                this.likeItem();
            }
        },
    },
    watch: {
        liveComments: {
            handler() {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.scrollToBottom(); // Scroll to the bottom after content is rendered
                    }, 50); // Add a small delay (50ms)
                });
            },
            deep: true, // Ensure the watcher detects changes within the array
        },
    },
    computed: {
        viewers() {
            if (this.isLive == false) {
                return this.$store.state.livecomment.viewers?.total_viewers || 0;
            } else {
                return this.$store.state.livecomment.viewers?.current_viewers || 0;
            }
        },
        usernames() {
            if (this.$store.state.helpers.usernameData[0] != undefined) {
                //console.log(this.$store.state.helpers.usernameData[0]['All Users']);
                return this.$store.state.helpers.usernameData[0]['All Users'];
            } else {
                return [];
            }
        },
        hashtags() {
            if (this.$store.state.helpers.hashtagData[0] != undefined) {
                //console.log(this.$store.state.helpers.hashtagData[0]['Hash Tags']);
                return this.$store.state.helpers.hashtagData[0]['Hash Tags'];
            } else {
                return [];
            }
        },
        linkPreviews() {
            if (this.$store.state.helpers.linkData != undefined) {
                //console.log(this.$store.state.helpers.linkData, 'computed');
                return this.$store.state.helpers.linkData;
            } else {
                //console.log('cleaned out');
                return undefined;
            }
        },
        webSocketConnected() {
            return this.$store.state.livecomment.webSocketConnected;
        },
        liveComments() {
            return this.$store.state.livecomment.liveComments || [];
        },
    },
});
</script>
<style scoped>
ion-spinner {
    /* --color: #54dc98; */
    margin-left: auto;
    margin-right: auto;
    display: block;
}

message-like {
    cursor: pointer;
    font-size: 24px
}

.message-like-active {
    cursor: pointer;
    font-size: 24px;
    color: red
}

#gif-button {
    position: absolute;
    /* bottom: 27px; */
    margin: 0px 0px 0 8px;
    right: 20px;
    z-index: 999;
}

#heart-button {
    position: absolute;
    /* bottom: 27px; */
    margin: 0px 0px 0 8px;
    right: 84px;
    z-index: 999;
}

#emoji-button {
    position: absolute;
    /* bottom: 27px; */
    margin: 0px 0px 0 8px;
    right: 54px;
    z-index: 999;
}

#post-button {
    position: absolute;
    /* bottom: 27px; */
    margin: 0px 0px 0 8px;
    right: 28px;
    z-index: 999;
}

.ios #gif-button, .ios #post-button, .ios #emoji-button, .ios #heart-button {
    bottom: 11px;
}

.footer {
    position: fixed;
    left: 0;
    bottom: 0;
}

.comment-reply-row {
    padding-left: 35px;
}

.comment-like {
    cursor: pointer;
    font-size: 24px
}

.comment-like-active {
    cursor: pointer;
    font-size: 24px;
    color: red
}

.chat-row {
    margin: 0px;
    align-items: center;
}

.live-comment-container {
  display: flex;
  flex-direction: column;
  height: 100%; /* Fill parent, not viewport or 30vh */
  position: relative;
}

.scrollable-container {
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0px;
  max-height: 40vh; /* Prevents chat from growing too large, adjust as needed */
}

ion-footer {
  flex-shrink: 0;
  width: 100%;
  background: var(--ion-background-color);
  /* No position: fixed! Let flexbox handle it */
}

.floating-heart {
  position: fixed; /* Use fixed positioning to align with the viewport */
  transform: translateX(-50%); /* Center horizontally */
  opacity: 0; /* Initially hidden */
  pointer-events: none; /* Prevent interaction */
  font-size: 24px;
  color: var(--ion-color-primary);
  transition: opacity 0.2s ease-in-out; /* Smooth fade-in/out */
  z-index: 9999; /* Ensure it's on top of other elements */
}

.animate-thumbs-up {
  animation: floatUpFadeOut 2.0s ease-in-out forwards; /* Reduced duration to make it quicker */
}

@keyframes floatUpFadeOut {
  0% {
    transform: translateX(-50%) translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(-600px); /* Move up further */
    opacity: 0; /* Fade out */
  }
}

</style>
